import React, { ReactNode } from 'react'
import { DispatchProp } from 'react-redux'
import { connectRedux } from '../../../helpers/connectRedux'
import { RouteComponentProps } from '../../../helpers/withRouter'
import { Button, InfoNote, Page, Spinner, ValidatedInput } from '../../../components'
import { isPasswordValid } from '../../../helpers'
import { images } from '../../../images'
import literalsService from '../../../services/literals-service'
import { changePasswordAction, setChangeNewPasswordAction, setChangePasswordAction, setChangeRepeatNewPasswordAction, setNotificationAction } from '../../../store/actions'
import { IStoreState } from '../../../store/states'
import StyledArticle from './styles'
import { appsStyleSelected } from '../../../helpers/app'
import { AuthenticatedRoutable } from '../../../models'
import { AnyAction } from 'redux'

interface IProps extends RouteComponentProps, DispatchProp<any> {
  password: string
  newPassword: string
  repeatNewPassword: string
  isChangingPassword: boolean
}
class ChangePassword extends AuthenticatedRoutable<IProps> {

  public componentDidMount(): void {
    super.componentDidMount()
  }

  public render(): ReactNode {

    const {
      password,
      newPassword,
      repeatNewPassword,
      isChangingPassword
    } = this.props
    if (isChangingPassword) {
      return (
        <article className="spinner-container">
          <Spinner />
        </article>
      )
    }
    return (
      <Page>
        <Page className={ `authenticated ${appsStyleSelected?.style}` }>
          <StyledArticle>
            <img src={ images['goBack'] } className='backButton' onClick={ this.handleGoBack } />
            <form onSubmit={ e => e.preventDefault() }>
              <section>
                <h3>{ literalsService.get('changePassword', true) }</h3>
                <ValidatedInput
                  name="password"
                  label={ literalsService.get('password', true) }
                  value={ password }
                  onChange={ this.onPasswordChange }
                  error={ !isPasswordValid(password) }
                  isPassword
                />
                <ValidatedInput
                  name="newPassword"
                  label={literalsService.get('newPassword', true)}
                  value={newPassword}
                  error={!isPasswordValid(newPassword)}
                  onChange={this.onNewPasswordChange}
                  isPassword
                />
                <ValidatedInput
                  name="repeatNewPassword"
                  label={literalsService.get('repeatNewPassword', true)}
                  value={repeatNewPassword}
                  error={!isPasswordValid(repeatNewPassword)}
                  onChange={this.onRepeatNewPasswordChange}
                  isPassword
                />
                { /* The rule the new password must follow, under the fields as in the mock. */ }
                <InfoNote literal="infoNewPassword" />
              </section>
              <Button
                title={ literalsService.get('save', true) }
                onPress={ this.saveNewPassword }
                className={ 'saveButton' }
                filled
                upper
                isDisabled={ this.buttonIsDisabled }
              />
            </form>
          </StyledArticle>
        </Page>
      </Page>
    )
  }

  private handleGoBack = (): void => {
    history.back()
  }

  private onPasswordChange = (password: string) => {
    this.props.dispatch(setChangePasswordAction(password))
  }

  private onNewPasswordChange = (newPassword: string) => {
    this.props.dispatch(setChangeNewPasswordAction(newPassword))
  }

  private onRepeatNewPasswordChange = (repeatNewPassword: string) => {
    this.props.dispatch(setChangeRepeatNewPasswordAction(repeatNewPassword))
  }

  private saveNewPassword = () => {
    const { dispatch } = this.props
    dispatch(changePasswordAction())
    dispatch(setNotificationAction({
      label: literalsService.get('passwordSaved', true),
      isError: false
    }))
    this.handleGoBack()
  }

  private get buttonIsDisabled(): boolean {
    const { password, newPassword, repeatNewPassword } = this.props
    return !isPasswordValid(password) || !isPasswordValid(newPassword) || password === '' || newPassword === '' || repeatNewPassword === '' || newPassword !== repeatNewPassword
  }
}

const mapStateToProps = ({ changePassword }: IStoreState) => ({
  ...changePassword
})

export default connectRedux(mapStateToProps, ChangePassword)
